import { ModelStore, handleStoreState } from "Stores/RESTStore/CoreStore";
import { observable, action, computed, runInAction, makeObservable } from "mobx";
import { API } from "General/API";
import { EditStore } from "Stores/RESTStore/EditStore";

export abstract class DataStore<T> extends ModelStore<T> {
  data: T = {} as T;
  editStore: EditStore<T>;

  constructor() {
    super();

    makeObservable(this, {
      data: observable.deep,
      id: computed,
      updateData: action,
      fetch: action.bound,
    });
  }

  get id(): number {
    return this.data[this.identifier];
  }

  clear() {
    this.data = {} as T;
  }

  /**
   * Fetches Data
   *
   * Default: Tries to fetch data from Collection
   * @param id ResourceID
   * @param fromList Setting it to false always requests from server
   */
  @handleStoreState()
  async fetch(id: number, fromList = true, params?) {
    this.clear();

    if (fromList) {
      runInAction(() => {
        this.data = this.getDataFromList(id);
      });
    }

    if (this.data === undefined) {
      const newData = await API.getData(this.url(id), params);
      runInAction(() => {
        this.data = newData;
      });
      this.updateList();
      this.updateEditStore();
    }
  }

  getDataFromList(id: number) {
    if (this.listStore) {
      return this.listStore.getItem(id);
    } else {
      return undefined;
    }
  }

  updateList() {
    if (this.listStore) {
      this.listStore.setItem(this.data);
    }
  }

  registerEditStore(editStore: EditStore<T>) {
    this.editStore = editStore;
  }

  updateEditStore() {
    if (this.editStore) {
      this.editStore.setData(this.data as unknown as object);
    }
  }

  updateData(data: T) {
    this.data = data;
  }
}
